export default __webpack_public_path__ + "static/media/intensivo-sp-logo.c71d59c6.svg";